import { User } from '../entities/User'
import { AuthRepository } from '../repositories/AuthRepository'

export class LoginUseCase {
  constructor(private readonly authRepository: AuthRepository) {}

  async execute(email: string, password: string): Promise<User> {
    if (!email?.includes('@')) {
      throw new Error('Please enter a valid email address')
    }

    if (!password || password.length < 6) {
      throw new Error('Password must be at least 6 characters long')
    }

    return this.authRepository.login(email, password)
  }
}
